<template>
  <div class="attend-panel">
    <p class="text-caption grey--text mb-3">
      출석할 때마다 🥕를 받아요 · 7일 채우면 다시 1일차부터 반복 · 누적 {{ attend.totalDays }}일
    </p>

    <div class="attend-grid">
      <v-card
        v-for="(reward, i) in rewards"
        :key="i"
        class="attend-card"
        :class="{ big: i === rewards.length - 1, stamped: i < stampedCount, next: i + 1 === nextDay && !checkedToday }"
        outlined
      >
        <div class="attend-card__day">{{ i + 1 }}일차</div>
        <div class="attend-card__emoji">🥕</div>
        <div class="attend-card__amount">+{{ reward }}</div>
        <div v-if="i < stampedCount" class="attend-card__stamp">출석</div>
      </v-card>
    </div>

    <div v-if="attendMsg" class="attend-msg">{{ attendMsg }}</div>
    <div class="d-flex justify-center">
      <v-btn
        class="attend-claim"
        rounded
        depressed
        dark
        color="#c98a2e"
        :loading="attendLoading"
        :disabled="checkedToday"
        @click="onAttend"
      >
        {{ checkedToday ? "오늘 출석 완료 ✓" : `오늘 출석하기 · +${rewards[nextDay - 1]} 🥕` }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import CurrencyApi from "../api/CurrencyApi";

export default {
  name: "AttendancePanel",
  data() {
    return {
      rewards: [10, 25, 50, 80, 120, 160, 200],
      attend: { totalDays: 0, lastCheckDate: null },
      attendLoading: false,
      attendMsg: "",
    };
  },
  computed: {
    // 현재 사이클에서 도장 찍힌 칸 수 (7칸 다 차면 7, 다음 출석 시 1로 리셋)
    stampedCount() {
      const t = this.attend.totalDays;
      const pos = t % 7;
      return pos === 0 && t > 0 ? 7 : pos;
    },
    // 이번에 받을 칸 (1~7)
    nextDay() {
      return (this.attend.totalDays % 7) + 1;
    },
    // KST 기준 오늘 이미 출석했는지
    checkedToday() {
      return this.attend.lastCheckDate === this.todayKST();
    },
  },
  created() {
    this.loadAttendance();
  },
  methods: {
    todayKST() {
      return new Date().toLocaleDateString("en-CA", { timeZone: "Asia/Seoul" });
    },
    async loadAttendance() {
      try {
        const [rewards, state] = await Promise.all([
          CurrencyApi.fetchAttendanceRewards(),
          CurrencyApi.fetchAttendance(),
        ]);
        this.rewards = rewards;
        this.attend = state;
      } catch (e) {
        console.error("loadAttendance failed", e);
      }
    },
    async onAttend() {
      if (this.attendLoading || this.checkedToday) return;
      this.attendLoading = true;
      this.attendMsg = "";
      try {
        const res = await CurrencyApi.attend();
        if (res.already) {
          this.attend.lastCheckDate = this.todayKST();
          this.attendMsg = "오늘은 이미 출석했어요 🙂";
        } else {
          this.attend = { totalDays: res.total_days, lastCheckDate: this.todayKST() };
          this.$store.commit("__setCurrencyBalance", res.balance);
          this.attendMsg = `${res.day}일차 출석 완료! +${res.reward} 🥕`;
          this.$emit("attended", res); // 부모가 후처리(다이얼로그 닫기 등) 가능
        }
      } catch (e) {
        console.error("attend failed", e);
        this.attendMsg = "출석 처리 중 오류가 발생했어요. 잠시 후 다시 시도해주세요.";
      } finally {
        this.attendLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.attend-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(96px, 1fr));
  gap: 10px;
  margin-bottom: 20px;
}
.attend-card {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  padding: 14px 8px;
  border-radius: 12px;
}
.attend-card.big {
  background: linear-gradient(135deg, #fff4e0, #ffe6c2);
  border-color: #f1c98a !important;
}
.attend-card.next {
  border-color: #e8743b !important;
  box-shadow: 0 0 0 2px rgba(232, 116, 59, 0.25);
}
.attend-card.stamped {
  opacity: 0.55;
}
.attend-card__day {
  font-size: 12px;
  color: #9a6a18;
  font-weight: 600;
}
.attend-card__emoji {
  font-size: 28px;
}
.attend-card__amount {
  font-size: 14px;
  font-weight: 800;
  color: #8a5d13;
}
.attend-card__stamp {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(-18deg);
  padding: 2px 8px;
  font-size: 13px;
  font-weight: 900;
  color: #d6307a;
  border: 2px solid #d6307a;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.6);
}
.attend-msg {
  text-align: center;
  margin-bottom: 10px;
  font-weight: 800;
  color: #e0892b;
}
.attend-claim {
  width: 100%;
  max-width: 360px;
  font-weight: 700 !important;
}
</style>
